import path from '@ps/bridge/path'

// 是否记录操作历史
export const recordHistory = true
// 制作页报错时 message 弹窗提示时间
export const elMessageErrorDuration = 10 * 1000
// 默认语言
export const defaultLanguage = 'zh-cn'

// 项目基础路径
export const projectBasicPath = path.PROJECT_BASIC_PATH
